import { neftApi } from "app/config";

import { removeEmptyValue } from "utils";
import { ApiTableResponse, ApiResponse, TransactionDTO, TransactionUpdateDTO } from "models";

// type NotificationType = "success" | "info" | "warning" | "error";

const reprocessApiWithTag = neftApi.enhanceEndpoints({
  addTagTypes: ["audit", "batch-summary", "transaction-batch", "transaction-error"],
});

const reportApiSlice = reprocessApiWithTag.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getTransactionReport: builder.query<ApiTableResponse<TransactionDTO>, any>({
      query: (transactionParams) => ({
        url: `/transaction/search`,
        method: "GET",
        params: removeEmptyValue(transactionParams),
      }),
      providesTags: [{ type: "transaction-batch" as const }],
    }),

    rePushSingleBatchToNIBSS: builder.mutation<ApiResponse<string>, { batchId: string }>({
      query: ({ batchId }) => ({
        url: `/push/${batchId}`,
        method: "PUT",
      }),
      invalidatesTags: (result, error, tags) => [
        { type: "audit" },
        { type: "batch-summary" },
        { type: "transaction-batch" as const },
        { type: "transaction-error" as const },
      ],
    }),

    updateBatchSingeTransaction: builder.mutation<ApiResponse<string>, TransactionUpdateDTO>({
      query: (transactionProps) => {
        return {
          url: "/transaction/single",
          method: "PUT",
          body: removeEmptyValue(transactionProps),
        };
      },
      invalidatesTags: (result, error, tags) => [
        { type: "audit" },
        { type: "batch-summary" },
        { type: "transaction-batch" as const },
        { type: "transaction-error" as const },
      ],
    }),
  }),
});

export const {
  useGetTransactionReportQuery,
  useRePushSingleBatchToNIBSSMutation,
  useUpdateBatchSingeTransactionMutation,
} = reportApiSlice;

export default reportApiSlice;
